import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { industries, teamMembers } from "../data/siteContent";
import Footer from "../ones/Footer";
import HomeAboutSection from "../ones/HomeAboutSection";
import HomeBanner1 from "../ones/HomeBanner1";
import HomePartners from "../ones/HomePartners";
import HomeServicesContent from "../ones/HomeServicesContent";
import HomeStats from "../ones/HomeStats";
import CallToAction from "../ones/callToAction";

export default function View() {
  const [ready, setReady] = useState(false);
  const appContext = useContext(AppContext);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <>
      <HomeBanner1 />
      <HomeStats />
      <HomeServicesContent />
      <HomePartners />
      {/* <section className="ags-section pt-0">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-7" data-aos="fade-right">
              <div className="ags-dark-panel h-100">
                <p className="ags-section-kicker text-secondary mb-3">
                  Industry Reach
                </p>
                <h2 className="section-title text-white mb-3">
                  From agriculture to mining, AGS translates spatial data into decisions
                </h2>
                <p className="text-white-50 mb-4">
                  Our work spans infrastructure, utilities, land development,
                  tourism, manufacturing, and transport. We pair field accuracy
                  with practical data products teams can actually use.
                </p>
                <div className="row g-3">
                  {industries.slice(0, 4).map((industry, index) => (
                    <div className="col-sm-6" key={industry.title} data-aos="fade-up" data-aos-delay={index * 40}>
                      <div className="ags-glass-chip">{industry.title}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-lg-5" data-aos="fade-left">
              <div className="ags-surface-panel h-100">
                <p className="ags-section-kicker mb-3">Leadership Snapshot</p>
                {teamMembers.slice(0, 3).map((member) => (
                  <div className="ags-team-listing" key={member.name}>
                    <img src={member.image} alt={member.name} />
                    <div>
                      <h6 className="font-bold mb-1">{member.name}</h6>
                      <p className="mNoMargin text-muted">{member.position}</p>
                    </div>
                  </div>
                ))}
                <button
                  className="btn btn-outline-primary btn-rounded btn-padded mt-3"
                  onClick={() => appContext.navTo({ item: "team" })}
                >
                  View Our Team
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <CallToAction />
      <Footer />
    </>
  );
}
